interface IProps {
  trxAddress: string;
  sendAddress: string;
}

const SendTransactionInfo = ({ trxAddress, sendAddress }: IProps) => {
  return (
    <div className="confirm-address-section">
      <div className="confirm-address-item">
        <span className="confirm-address-text text-base font-medium">{trxAddress}</span>
      </div>
      <div className="confirm-arrow"></div>
      <div className="confirm-address-item">
        <span className="confirm-address-text text-base font-medium">{sendAddress}</span>
      </div>
    </div>
  );
};

export default SendTransactionInfo;
